import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  TemplateRef,
} from '@angular/core';
import { TypeaheadOrder } from 'ngx-bootstrap/typeahead';
import { RR_FILTER_TYPE } from '../../../common/enum/filters/filter-type.enum';
import { RRIFilterOption } from '../../../common/interfaces/filters/filter-options.interface';
import { RRIFilterOutput } from '../../../common/interfaces/filters/filter-output.interface';
import { RRIFilter } from '../../../common/interfaces/filters/filter.interface';
import { RRIDropdownOptionTemplate } from '../../../form-inputs/interfaces/dropdown-option-template.interface';
import { RRIInputOption } from '../../../form-inputs/interfaces/input-option.interface';
import { RRIInput } from '../../../form-inputs/interfaces/input-settings.interface';

@Component({
  selector: 'rr-dropdown-filter',
  templateUrl: './dropdown-filter.component.html',
  styleUrls: ['./dropdown-filter.component.scss'],
})
export class DropdownFilterComponent<T>
  implements OnInit, OnChanges, AfterViewInit
{
  public sortConfig: TypeaheadOrder;
  public dropDownOptions: RRIFilterOption<T>[];
  public dropDownSettings: RRIInput<RRIInputOption<T>>;

  private _defaultValue: RRIFilterOption<T>;

  @Input() model: RRIFilter<RRIFilterOption<T>, T>;
  @Input() options: RRIFilterOption<T>[];
  @Input() optionsTemplate: TemplateRef<RRIDropdownOptionTemplate<string>>;
  @Input() formComponentSettings: RRIInput<RRIInputOption<T>>;
  @Output() changedFilter: EventEmitter<RRIFilterOutput<RRIFilterOption<T>>> =
    new EventEmitter();
  @Output() filterClicked: EventEmitter<RRIFilterOutput<RRIFilterOption<T>>> =
    new EventEmitter();
  @Output() cleanFilterClicked: EventEmitter<RRIFilter<RRIFilterOption<T>, T>> =
    new EventEmitter();

  constructor() {
    this.sortConfig = {
      direction: 'asc',
      field: 'value',
    };
  }

  ngOnInit(): void {
    this.setDropDownSettings();
  }

  ngAfterViewInit(): void {
    this._defaultValue = Object.assign(
      {},
      this.model?.filterBy?.defaultValue ?? null,
    );
    this.setDropDownSettings();
  }

  ngOnChanges(): void {
    this.dropDownOptions = Object.assign({}, this.options);
    this._defaultValue = this.model?.filterBy?.defaultValue ?? null;
  }

  public changeSelectedFilter(event: RRIFilterOption<T>): void {
    if (!event || event.id === '') {
      return;
    }
    if (this.isAnOption(event)) {
      this.model.filterBy.value = Object.assign({}, event);
      console.log('changedFilter fired value: ', {
        type: RR_FILTER_TYPE.DROPDOWN_SELECT,
        filterBy: {
          ...this.model.filterBy,
          value: event,
        },
      });
      this.changedFilter.emit({
        type: RR_FILTER_TYPE.DROPDOWN_SELECT,
        filterBy: {
          ...this.model.filterBy,
          value: event,
        },
      });
    } else {
      this.setDefaultValues();
    }
  }

  public onClearInput(_event: any): void {
    this.setDefaultValues();
    this.cleanFilterClicked.emit(this.model);
  }

  private setDropDownSettings(): void {
    if (!this.formComponentSettings) {
      this.dropDownSettings = {
        fieldName: this.model?.settings?.title ?? '',
        label: this.model?.settings?.title ?? '',
        placeholder: this.model?.settings?.title ?? '',
        tooltip: '',
        defaultValue: null,
        showFieldHasValue: this.model?.settings?.showFieldHasValue ?? false,
      };
      return;
    }
    this.dropDownSettings = this.formComponentSettings;
  }

  private isAnOption(item: RRIFilterOption<T>): boolean {
    return Object.assign(
      {},
      this.options.some(
        (option) => option.id === item.id && option.value === item.value,
      ),
    );
  }

  private setEmptyOption(): void {
    this.model.filterBy.value = {
      id: '',
      value: null,
    };
  }

  private setDefaultValues(): void {
    if (
      this.model.filterBy &&
      this.model.filterBy.defaultValue &&
      typeof this.model.filterBy.defaultValue.value !== 'undefined' &&
      typeof this.model.filterBy.defaultValue.id !== 'undefined'
    ) {
      this.model.filterBy.value = Object.assign({}, this._defaultValue);
      this.changedFilter.emit({
        type: RR_FILTER_TYPE.DROPDOWN_SELECT,
        filterBy: {
          ...this.model.filterBy,
          value: Object.assign({}, this.model.filterBy.value),
        },
      });
    } else {
      this.setEmptyOption();
      this.changedFilter.emit({
        type: RR_FILTER_TYPE.DROPDOWN_SELECT,
        filterBy: {
          ...this.model.filterBy,
          value: null,
        },
      });
    }
  }
}
